import styled, { css } from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledContainer = styled.div`
  display: flex;
  gap: 1em;
  flex-direction: column;
  padding: 1em 0;
  position: relative;

  ${themeMedia.tablet`
    flex-direction: row;
    justify-content: space-between;
    padding: 2em 0;
    margin-bottom: 2em;
  `}

  ${({ direction }) =>
    direction === 'horizontal' &&
    css`
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
    `}

  ${({ noMargin }) =>
    noMargin &&
    css`
      margin: 0 !important;
    `}
  
  ${({ noPadding }) =>
    noPadding &&
    css`
      padding: 0 !important;
    `}
`

export const StyledStepLabel = styled.div`
  width: 32px;
  height: 32px;
  background: ${themeStyles.colors.accentColors.secondary.main};
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  flex-shrink: 0;

  &:after {
    content: '';
    height: calc(100% - 32px);
    width: 2px;
    background: ${themeStyles.colors.lightGreys[4].main};
    position: absolute;
    left: 16px;
    transform: translateX(-50%);
    top: calc(32px + 0.5em);
  }

  ${themeMedia.tablet`
    width: 100%;
    max-width: 90px;
    height: 100%;
    max-height: 90px;
    font-size: 2.5em;
    margin-bottom: 0.5em;

    &:after {
      width: calc(100% - 90px - 0.5em);
      left: calc(90px + 0.5em);
      height: 3px;
      transform: none;
      top: 45px;
    }
  `}
`

export const StyledStepWrapper = styled.div`
  display: flex;
  gap: 1em;
  width: 100%;
  position: relative;

  ${themeMedia.tablet`
    display: block;
  `}

  &:last-child {
    ${StyledStepLabel}:after {
      display: none;
    }
  }
`

export const StyledCheckStepContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  &::before {
    position: absolute;
    content: '';
    border-bottom: 2px solid ${themeStyles.colors.lightGreys[4].main};
    width: 100%;
    top: 50%;
    left: -50%;
    z-index: 0;
  }

  &::after {
    position: absolute;
    content: '';
    border-bottom: 2px solid ${themeStyles.colors.lightGreys[4].main};
    width: 100%;
    top: 50%;
    left: 50%;
    z-index: 0;
  }

  &:first-child::before {
    content: none;
  }
  &:last-child::after {
    content: none;
  }
`
